import React, { useRef, useEffect, useState, useContext } from "react";
import classes from "./Hero.module.css";
import OptimizedImage from "../../Common/OptimizedImage/OptimizedImage";

// Import optimized images (fallback to originals if optimized versions don't exist)
import IMG1 from "../../../assets/optimized/HeroImage1.webp";
import IMG2 from "../../../assets/optimized/HeroImage2.webp";
import HeroBook1 from "../../../assets/optimized/HeroBook1.webp";

import { toast } from "react-toastify";
import data from "../../Data.json";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import { Autoplay, EffectFade } from "swiper/modules";
import axios from "axios";
import AuthContext from "../../Common/authContext";
import { useDispatch, useSelector } from "react-redux";
import { addSearchData, editSearchData } from "../../redux/productSlice";
import { useNavigate } from "react-router-dom";

const HeroOptimized = () => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const authCtx = useContext(AuthContext);
  const [isBlurred, setIsBlurred] = useState(true);
  const [expandedTitle, setExpandedTitle] = useState("");
  const [image, setimage] = useState(HeroBook1);
  const [parent, setParent] = useState([]);
  const [subparent, setSubparent] = useState([]);
  const [heroData, setheroData] = useState([]);
  const [child, setChild] = useState([]);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Preload critical resources
  useEffect(() => {
    // Preload the LCP image immediately
    const preloadLCPImage = () => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = IMG1;
      link.fetchPriority = 'high';
      document.head.appendChild(link);
    };

    // Preload critical fonts if not already done
    const preloadFonts = () => {
      const fontLink = document.createElement('link');
      fontLink.rel = 'preload';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
      fontLink.as = 'style';
      fontLink.crossOrigin = 'anonymous';
      document.head.appendChild(fontLink);
    };

    preloadLCPImage();
    preloadFonts();
  }, []);

  const handleTitleOver = (title) => {
    setExpandedTitle(title);
  };

  useEffect(() => {
    EnParentWithtitle.forEach((item) => {
      if (expandedTitle === item.id) {
        setimage(item.image);
      }
    });
  }, [expandedTitle]);

  const EnParentWithtitle = parent?.map((category) => ({
    ...category,
    _nom: category._nom
      ? category._nom.substring(0, 20) +
        (category._nom?.length > 20 ? "..." : "")
      : "",
  }));

  const EnSubParentWithtitle = subparent?.map((category) => ({
    ...category,
    _nom: category._nom
      ? category._nom.substring(0, 20) +
        (category._nom?.length > 20 ? "..." : "")
      : "",
  }));

  const EnChildWithtitle = child?.map((category) => ({
    ...category,
    _nom: category._nom
      ? category._nom.substring(0, 20) +
        (category._nom?.length > 20 ? "..." : "")
      : "",
  }));

  useEffect(() => {
    if (Array.isArray(authCtx.categories)) {
      const categories = authCtx.categories.filter(itt => itt?._nom !== "");

      categories.forEach((category) => {
        const niveau = category.niveau;

        if (niveau === 1) {
          setParent((prevParent) => [...prevParent, category]);
        } else if (niveau === 2) {
          setSubparent((prevSubparent) => [...prevSubparent, category]);
        } else if (niveau === 3) {
          setChild((prevChild) => [...prevChild, category]);
        }
      });
    }
  }, [authCtx.categories]);

  const fetchHeroData = async () => {
    setIsBlurred(true);
    try {
      const response = await axios.get(
       `${process.env.REACT_APP_TESTING_API}/website-sections?ecom_type=${process.env.REACT_APP_ECOM_TYPE}&section_id=home-hero`
      );
      setheroData(response.data.data);
    } catch (error) {
      console.error('Error fetching hero data:', error);
    } finally {
        setIsBlurred(false);
    }
  };

  useEffect(() => {
    fetchHeroData();
  }, []);

  const handleChildClick = async (id, event) => {
    event.stopPropagation();
    let storedCategories = JSON.parse(localStorage.getItem("categories")) || [];
    if (storedCategories.includes(id)) {
      storedCategories = storedCategories.filter((catId) => catId !== id);
    } else {
      storedCategories.push(id);
    }
  
    localStorage.setItem("categories", JSON.stringify(storedCategories));
    dispatch(addSearchData({ category: storedCategories }));
    navigate(`/books`);
  };

  return (
    <>
      <div className={classes.home_container} style={{ position: "relative" }}>
        <div
                  id="new_products"
                  style={{ position: "absolute", top: "60%" }}
                ></div>
                <div className={classes.DropDownContainer}>
                  <div
                    className={classes.DropDownTitle}
                    onClick={() => console.log(heroData)}
                  >
                    {data.HomePage.Hero.title[language]}
                  </div>
                  <div className={classes.titlesContainer}>
                    {EnParentWithtitle?.map((item, index) => (
                      <div
                      onClick={(event) => handleChildClick(item.id, event)}
                        // onClick={() => {
                        //   localStorage.removeItem("category");
                        //   localStorage.setItem("category", item.id);
                        //   dispatch(editSearchData({ category: item.id }));
                        //   navigate(`/books`);
                        // }}
                        key={index}
                        className={`${
                          expandedTitle === item.id
                            ? classes.titleSelected
                            : classes.title
                        }`}
                        onMouseOver={() => {
                          handleTitleOver(item.id);
                        }}
                        onMouseLeave={() => {
                          handleTitleOver("");
                        }}
                      >
                        <p>
                          {item._nom}
                          <KeyboardArrowRightIcon
                            style={{ marginBottom: "-1%", paddingLeft: "2%" }}
                          />
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                {expandedTitle && (
                  <div
                    className={classes.subtitleContainer}
                    onMouseOver={() => handleTitleOver(expandedTitle)}
                    onMouseLeave={() => handleTitleOver("")}
                  >
                    <div className={classes.subtitles}>
                      {parent?.slice(0, 9)?.map((item, index) => (
                        <div key={index}>
                          {expandedTitle === item.id && (
                            <div className={classes.titlescontainer11}>
                              {/* Filter subparent based on parent_id */}
                              {EnSubParentWithtitle.filter(
                                (subItem) => subItem.b_usr_articletheme_id === item.id
                              )
                                ?.slice(0, 12)
                                ?.map((subItem, subIndex) => (
                                  <div
                                    key={subIndex}
                                    className={classes.title11}
                                    
                      onClick={(event) => handleChildClick(subItem.id, event)}
                                    // onClick={() => {
                                    //   localStorage.setItem("category", subItem.id);
                                    //   dispatch(
                                    //     editSearchData({ category: subItem.id })
                                    //   );
                                    //   navigate(`/books`);
                                    // }}
                                  >
                                    <span
                                      style={{
                                        color: "var(--primary-color)",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {" "}
                                      +{" "}
                                    </span>
                                    <p>{subItem._nom}</p>
                                    <div className={classes.subtitle11}>
                                      <ul
                                        style={{
                                          listStyleType: "disc",
                                          width: "fit-contant",
                                          marginLeft: "2em",
                                          color: "var(--primary-color)",
                                        }}
                                      >
                                        {EnChildWithtitle.filter(
                                          (childItem) =>
                                            childItem.b_usr_articletheme_id ===
                                            subItem.id
                                        )
                                          ?.slice(0, 12)
                                          ?.map((childItem, childIndex) => (
                                            <li
                                              key={childIndex}
                                              onClick={(event) => handleChildClick(childItem.id, event)}
                                              // onClick={(e) => {
                                              //   e.stopPropagation();
                                              //   localStorage.setItem(
                                              //     "category",
                                              //     childItem.id
                                              //   );
                                              //   dispatch(
                                              //     editSearchData({
                                              //       category: childItem.id,
                                              //     })
                                              //   );
                                              //   navigate(`/books`);
                                              // }}
                                            >
                                              <span className={classes.subSubtitles}>
                                                {childItem._nom}
                                              </span>
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className={classes.imageContainer}>
                      <img src={image} alt="" style={{ width: "100%" }} />
                    </div>
                  </div>
                )}

        <div className={classes.swiper_container} style={{width:'100%',display:"flex"}}>
          {(heroData?.length !== 0 && heroData[0]?.hero_sections?.length !== 0) && (
            <Swiper
              effect={"fade"}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              loop={true}
              modules={[Autoplay, EffectFade]}
              className="mySwiper"
              style={{width:'100%'}}
            >
              {heroData[0]?.hero_sections?.map((props, index) => {
                return (
                  <SwiperSlide key={index} style={{width:'100%'}} className={classes.slides}>
                    <div style={{display:'flex',flexDirection:'column',width:'100%',height:'100%'}}>
                      <OptimizedImage
                        src={props?.image1 || IMG1}
                        alt={`Hero slide ${index + 1}`}
                        className={classes.img}
                        priority={index === 0}
                        sizes="100vw"
                        loading={index === 0 ? 'eager' : 'lazy'}
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
          
          {((heroData?.length === 0 || heroData[0]?.hero_sections?.length === 0) && !isBlurred) && (
            <Swiper
              effect={"fade"}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              loop={true}
              modules={[Autoplay, EffectFade]}
              className="mySwiper"
              style={{width:'100%'}}
            >
              <SwiperSlide className={classes.slides} style={{width:'100%'}}>
                <OptimizedImage 
                  src={IMG1} 
                  alt="Featured books collection" 
                  className={classes.img}
                  priority={true}
                  sizes="100vw"
                  loading="eager"
                />
              </SwiperSlide> 
              <SwiperSlide className={classes.slides} style={{width:'100%'}}>
                <OptimizedImage 
                  src={IMG2} 
                  alt="Book showcase" 
                  className={classes.img}
                  priority={false}
                  sizes="100vw"
                  loading="lazy"
                />
              </SwiperSlide> 
            </Swiper>
          )}
          
          {/* {((heroData?.length === 0 || heroData[0]?.hero_sections?.length === 0) && isBlurred) && (
            <div className={classes.img} style={{background:"#f8f9fa"}}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                color: '#671929',
                fontSize: '18px'
              }}>
                Loading...
              </div>
            </div>
          )} */}
        </div>
      </div>
    </>
  );
};

export default HeroOptimized;
